import styles from "./styles.module.scss";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { ContactPage } from "./contactPage";
import { HomePage } from "./homePage";
import Alert from "components/alert";
import { lazy, Suspense, useEffect, useState } from "react";
import AuthService from "utilities/authService";
import { Loader } from "semantic-ui-react";
import { TypographyWrapper } from "./shared/typography";
import { DisclaimerPage } from "./disclaimerPage";
import { PrivacyPage } from "./privacyPage";
import { TermsPage } from "./termsPage";

const PromoVideoPage = lazy(() => import("./promoVideoPage"));

export function PublicPages() {
  const [authChecked, setAuthChecked] = useState(false);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    // user already signed in?
    AuthService.GetCurrentAuthenticatedUser()
      .then(() => {
        // going to root path, push to internal app
        if (location.pathname === "/") {
          history.push("/app/properties");
        }
      })
      .catch(() => {}) // ignores react-scripts errors during dev
      .finally(() => {
        setAuthChecked(true);
      });
  }, []);

  if (!authChecked) return null;

  return (
    <TypographyWrapper>
      <Alert scope="Public" />
      <Switch>
        <Route path="/contact" component={ContactPage} />
        <Route
          path="/promo-video"
          render={() => (
            <Suspense fallback={<Loader active />}>
              <PromoVideoPage />
            </Suspense>
          )}
        />
        <Route path="/privacy" component={PrivacyPage} />
        <Route path="/terms" component={TermsPage} />
        <Route path="/disclaimer" component={DisclaimerPage} />
        <Route path="/" component={HomePage} />
      </Switch>
    </TypographyWrapper>
  );
}
